export default __webpack_public_path__ + "static/media/background_teams-04.2a98dd09.jpg";